export type OrdinalIndicator = "st" | "nd" | "rd" | "th";

const getOrdinalForGrade = (grade: number): OrdinalIndicator => {
  if (grade % 10 === 1 && grade % 100 !== 11) {
    return "st";
  }

  if (grade % 10 === 2 && grade % 100 !== 12) {
    return "nd";
  }

  if (grade % 10 === 3 && grade % 100 !== 13) {
    return "rd";
  }

  return "th";
};

export default getOrdinalForGrade;
